module.exports = __webpack_public_path__ + "static/media/notes.fce92e01.svg";